<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        div(slot="header").d-flex.justify-content-between.page-header
          b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone", style="padding-left: 0")
            div
              span.page-title {{$t('service')}} {{$t('payment')}} {{$t('history')}}
              b-button(variant="link", size="sm", style="padding: 0.25rem 0.7rem;", , target="_blank", href="https://www.tosspayments.com/faq")
                //icon(name="bookmark", style="margin:0 4px 0 2px;")
                span {{$t('tutorial-license')}}
        b-card.table-card
          b-table(
            :items="payments",
            :fields="fields",
            :current-page="page.current",
            :per-page="page.per",
            :empty-text="$t('no-content')",
            show-empty)
            template(slot="HEAD_create_time", slot-scope="data") {{$t('payment_date')}}
            template(slot="HEAD_type", slot-scope="data") {{$t('payment_type')}}
            template(slot="HEAD_device_count", slot-scope="data") {{$t('device_vol')}}
            template(slot="HEAD_price", slot-scope="data") {{$t('price')}}
            template(slot="HEAD_payment_method", slot-scope="data") {{$t('payment_method')}}
            template(slot="HEAD_remarks", slot-scope="data") {{$t('remark')}}

            template(slot="create_time", slot-scope="row") {{row.item.create_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt)}}
            template(slot="type", slot-scope="row") {{$t(row.item.type)}}
            template(slot="payment_method", slot-scope="row") {{$t(row.item.payment_method)}}
            template(slot="price", slot-scope="row") {{row.item.price | comma}} {{$t('WON')}}
          div.d-flex.justify-content-between.align-items-center(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination.my-0.float-right(
              size="sm"
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current")
</template>

<script>
import {user} from '../../api/access'
import {PaymentAPI} from '../../api'

var usr

export default {
  name: 'payments-component',
  created () {
    usr = user()
  },
  data () {
    return {
      fields: [
        { key: 'create_time', label: this.$t('payment_date') },
        { key: 'type', label: this.$t('device_type') },
        {
          key: 'device_count',
          label: this.$t('no_devices'),
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'price',
          label: this.$t('price'),
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'payment_method',
          label: this.$t('payment_method'),
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        { key: 'remarks', label: this.$t('remark') }
      ],
      page: {
        total: 0,
        per: 10,
        current: 1,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      paymentList: []
    }
  },
  methods: {
    payments (ctx) {
      let params = {
        order: 'desc',
        by: 'start_date',
        limit: ctx.perPage,
        offset: (ctx.currentPage - 1) * ctx.perPage,
        user_pk: usr.pk
      }
      return PaymentAPI.get('', {params})
        .then(resp => {
          resp.data.objects.forEach(obj => {
            obj.create_time = obj.create_time.slice(0, 10);
          })
          this.page.total = resp.data.meta.total_count
          return resp.data.objects
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  //.card-footer {
  //  border-top: none;
  //  padding: 0.3rem 1.25rem;
  //}
}

::v-deep .b-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4), th:nth-child(5) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 12% !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after, th:nth-child(4)::after, th:nth-child(5)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(6) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }
}
</style>
